import LegalDocument, { LegalSection } from '../components/legal/LegalDocument';

export default function Privacy() {
  return (
    <LegalDocument title="Privacy Policy" lastUpdated="24 July 2026">
      <LegalSection title="1. Who we are">
        <p>
          PropScope (propscope.co.uk) is operated by Geekybee Limited (&quot;we&quot;,
          &quot;us&quot;). We are the data controller for personal data described here.
        </p>
        <p>
          Contact:{' '}
          <a href="mailto:info@geekybee.net" className="text-emerald-400 hover:underline">
            info@geekybee.net
          </a>
        </p>
      </LegalSection>

      <LegalSection title="2. What data we collect">
        <p><strong className="text-slate-300">Account data:</strong> name, email address,
          password (stored hashed), role, company name (if provided), subscription status.</p>
        <p><strong className="text-slate-300">Usage data:</strong> pages viewed, features
          used, search filters, login timestamps, IP address, browser user-agent (for
          security and support).</p>
        <p><strong className="text-slate-300">Billing data:</strong> processed by Stripe
          (payment method, billing address, transaction history). We store Stripe customer
          and subscription identifiers, not full card numbers.</p>
        <p><strong className="text-slate-300">Content you provide:</strong> property
          uploads, alert preferences, watchlists, identity-vault documents (if you use
          those features), and support correspondence.</p>
        <p><strong className="text-slate-300">Location:</strong> only if you use GPS-based
          area lookup — we use coordinates to resolve a postcode; we do not continuously
          track your location.</p>
      </LegalSection>

      <LegalSection title="3. How we use your data">
        <p>We process personal data to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Provide and secure the Service (contract)</li>
          <li>Manage subscriptions and trials via Stripe (contract)</li>
          <li>Send service emails (password reset, account notices) (contract / legitimate interests)</li>
          <li>Send optional alerts you configure (consent / contract)</li>
          <li>Improve the Service and prevent abuse (legitimate interests)</li>
          <li>Comply with legal obligations</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Legal basis (UK GDPR)">
        <p>
          We rely on: performance of a contract (account and subscription); legitimate
          interests (security, analytics, product improvement — balanced against your
          rights); consent where we ask explicitly (e.g. marketing if offered); and legal
          obligation where applicable.
        </p>
      </LegalSection>

      <LegalSection title="5. Sharing and processors">
        <p>We use trusted processors, including:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong className="text-slate-300">Stripe</strong> — payments and subscriptions (may transfer outside the UK under appropriate safeguards)</li>
          <li><strong className="text-slate-300">Email provider (Brevo/Sendinblue)</strong> — transactional email</li>
          <li><strong className="text-slate-300">Hosting (Hetzner / infrastructure providers)</strong> — application and database hosting in the EU/EEA</li>
        </ul>
        <p>
          We do not sell your personal data. We may disclose data if required by law or to
          protect our rights and users.
        </p>
      </LegalSection>

      <LegalSection title="6. Cookies and local storage">
        <p>
          We use essential cookies and browser local storage for login sessions (access and
          refresh tokens), preferences, and security. We do not use third-party advertising
          cookies on the core app. A fuller cookie notice will be published with our
          formal policy.
        </p>
      </LegalSection>

      <LegalSection title="7. Retention">
        <p>
          We keep account data while your account is active and for a reasonable period
          afterwards (typically up to 6 years where needed for tax, billing, or legal
          claims). Security logs may be retained for up to 12 months. You may request
          deletion subject to legal and billing record requirements.
        </p>
      </LegalSection>

      <LegalSection title="8. Your rights">
        <p>
          Under UK data protection law you may have the right to access, rectify, erase,
          restrict, object, and port your data, and to withdraw consent where processing
          is consent-based. You may lodge a complaint with the ICO (ico.org.uk).
        </p>
        <p>
          To exercise rights, email{' '}
          <a href="mailto:info@geekybee.net" className="text-emerald-400 hover:underline">
            info@geekybee.net
          </a>
          . We will respond within one month.
        </p>
      </LegalSection>

      <LegalSection title="9. Open data and third-party content">
        <p>
          Property and area pages may include data from HM Land Registry and other public
          or licensed sources. That data is not your personal data. Land Registry Price
          Paid Data is subject to the Open Government Licence — attribution is shown in
          the Service where required.
        </p>
      </LegalSection>

      <LegalSection title="10. Children">
        <p>
          The Service is not directed at under-18s. We do not knowingly collect data from
          children.
        </p>
      </LegalSection>

      <LegalSection title="11. Changes">
        <p>
          We may update this policy. Material changes will be notified via the Service or
          email where appropriate. The &quot;Last updated&quot; date will change accordingly.
        </p>
      </LegalSection>

      <LegalSection title="12. Related documents">
        <p>
          See also our{' '}
          <a href="/terms" className="text-emerald-400 hover:underline">Terms &amp; Conditions</a>.
        </p>
      </LegalSection>
    </LegalDocument>
  );
}
